import React from 'react';
import { useRouter } from '../../components';

export function SearchBar({onCloseMenu}) {
  const [keyword, setKeyword ] = React.useState('')
  const { navigate } = useRouter();
  
  function search(e) {
    e.preventDefault();
    if (onCloseMenu) {
      onCloseMenu();
    }
    navigate('/search-results?q=' + encodeURIComponent(keyword))
  }
  
  function onChange(e) {
    setKeyword(e.target.value);
  }
  
  return (
    <form className="searchBar" onSubmit={(e) => search(e)}>
      <div className="searchBar__container">
        <img src='/assets/icons/glass.png' className="searchBar__icon" alt="Search" />
        <input 
          type="text" 
          className="searchBar__input" 
          placeholder="Search and Discover" 
          value={keyword} 
          onChange={onChange}
        />
      </div>
    </form>);
}
